import styled from 'styled-components';
import { DarkTheme } from 'src/packages/theme';
import { HEADER_HEIGHT } from 'src/packages/common/layout';

export const HeaderContainer = styled.header`
  grid-area: header;
  width: 100%;
  height: ${HEADER_HEIGHT};
  background-color: ${DarkTheme.colors.background.secondary.BG1};
  direction: ltr;
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: 0 24px;
  position: relative;
  z-index: 11000;

  a {
    cursor: pointer;
    position: relative;

    > *,
    * {
      transition: color 0.2s ease-in;
    }

    &:hover {
      > span {
        cursor: pointer;
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.md} {
    padding: 0 16px;
  }
`;

export const HeaderLeftPart = styled.div`
  display: flex;
  align-items: center;
  direction: ltr;
  gap: 60px;
`;

export const MainNavWrapper = styled.div`
  display: flex;
  align-items: center;
  direction: ltr;
  gap: 24px;

  > a:hover {
    > span {
      color: ${(props) => props.theme.colors.palette.primary};
    }
  }

  ${({ theme }) => theme.mediaQueries.md} {
    display: none;
  }
`;

export const HeaderRightPart = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-left: auto;
  direction: ltr;

  svg {
    &:not(:${(props) => (props.theme.rtl ? 'last-of-type' : 'first-of-type')}) {
      margin-left: 25px;
    }
  }

  ${({ theme }) => theme.mediaQueries.md} {
    display: none;
  }
`;

export const HeaderMobileIcons = styled.div`
  display: none;
  align-items: center;
  margin-left: auto;
  direction: ltr;
  gap: 16px;

  ${({ theme }) => theme.mediaQueries.md} {
    display: flex;
  }
`;

export const LanguageCurrencyItemWrapper = styled.div<{ minWidth: string; bgHoverColor: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 20px;
  border-radius: 8px;
  width: 100%;
  min-width: ${(props) => props.minWidth ?? 'unset'};

  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.bgHoverColor};

    * {
      cursor: pointer !important;
    }
  }
`;

export const NotificationPopoverContentWrapper = styled.div`
  div[role='tabpanel'].is-selected {
    margin: 0px;
  }
  width: 330px;
  max-height: 426px;
  overflow-y: auto;
  overflow-x: none;
`;

export const NotificationsItemWrapper = styled.div<{
  menuItemBgHoverColor: string;
  clickable: boolean;
}>`
  display: flex;
  width: 100%;

  .content {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block !important;
    * {
      display: inline-block;
      font-size: inherit !important;
      font-weight: inherit !important;
    }
    & :first-child {
      display: inline !important;
    }
  }
  ${({ clickable, menuItemBgHoverColor }) =>
    clickable
      ? `
        cursor: pointer;
        * {
          cursor: pointer !important;
        }
        &:hover {
          background-color: ${menuItemBgHoverColor};
        } 
      `
      : ``}
`;
